// extracted by mini-css-extract-plugin
module.exports = {"shareLinkIconWrapper":"mobileShareLink_shareLinkIconWrapper__2MF5J","shareLinkIcon":"mobileShareLink_shareLinkIcon__2Nkux"};